/** Unwrap `{ success, data }` / `{ data }` API envelopes (same pattern as member.ts). */
export function unwrapResponse<T>(response: unknown): T {
  if (response === null || response === undefined) {
    return response as T;
  }

  if (typeof response !== 'object') {
    return response as T;
  }

  const obj = response as Record<string, unknown>;

  if ('success' in obj && obj.success === false) {
    const message = (obj.message as string) || 'Request failed';
    throw new Error(message);
  }

  if ('data' in obj && obj.data !== undefined) {
    const innerData = obj.data as Record<string, unknown>;
    if (typeof innerData === 'object' && innerData !== null && 'data' in innerData) {
      return innerData.data as T;
    }
    return obj.data as T;
  }

  return response as T;
}
